import classNames from 'classnames';

import styles from './_index.module.scss';

interface ErrorTextProps extends React.HTMLAttributes<HTMLElement> {
  text?: string;
}

const ErrorText = <T extends React.ElementType>({
  as,
  children,
  className,
  text,
  ...props
}: ErrorTextProps & PolymorphicProps<T>) => {
  const Component = as || 'div';

  return (
    <Component className={classNames(styles['error-text'], className)} {...props}>
      <div className={styles['error-text-dot']} />
      {children || <p>{text}</p>}
    </Component>
  );
};

export default ErrorText;
